import { useStore } from "../store";

export const useClient = () => {
 const [state] = useStore()
 const { client } = state
 
 return client
}

export default useClient